import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  isDangerous?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDangerous = false,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-rs-jet border border-rs-jet-light rounded-lg shadow-2xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-rs-jet-light">
          <div className="flex items-center gap-3">
            {isDangerous && (
              <AlertTriangle className="text-rs-red" size={24} />
            )}
            <h2 className="text-xl font-semibold text-rs-off-white">{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="text-rs-off-white/70 hover:text-rs-off-white transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6">
          <p className="text-rs-off-white text-base leading-relaxed">
            {message}
          </p>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-rs-jet-light">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-rs-jet-light hover:bg-rs-jet-light/70 text-rs-off-white font-semibold rounded transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            className={`px-4 py-2 font-semibold rounded transition-colors ${
              isDangerous
                ? 'bg-rs-red/70 hover:bg-rs-red text-white'
                : 'bg-rs-green hover:bg-rs-light-green text-rs-black'
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;

